// source: pbtypes/gen/planner/spatial_waypoints_command.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_planner_movement_waypoint_pb = require('../../../pbtypes/gen/planner/movement_waypoint_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_movement_waypoint_pb);
goog.exportSymbol('proto.planner.SpatialWaypointsCommand', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.planner.SpatialWaypointsCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.planner.SpatialWaypointsCommand.repeatedFields_, null);
};
goog.inherits(proto.planner.SpatialWaypointsCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.planner.SpatialWaypointsCommand.displayName = 'proto.planner.SpatialWaypointsCommand';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.planner.SpatialWaypointsCommand.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.planner.SpatialWaypointsCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.planner.SpatialWaypointsCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.planner.SpatialWaypointsCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.SpatialWaypointsCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
creationUtime: jspb.Message.getFieldWithDefault(msg, 1, 0),
sampleUtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
positionAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
velocityAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
maxAcceleration: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
spatialWaypointsList: jspb.Message.toObjectList(msg.getSpatialWaypointsList(),
    pbtypes_gen_planner_movement_waypoint_pb.MovementWaypoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.planner.SpatialWaypointsCommand}
 */
proto.planner.SpatialWaypointsCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.planner.SpatialWaypointsCommand;
  return proto.planner.SpatialWaypointsCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.planner.SpatialWaypointsCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.planner.SpatialWaypointsCommand}
 */
proto.planner.SpatialWaypointsCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setCreationUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setSampleUtime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPositionAggressiveness(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setVelocityAggressiveness(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxAcceleration(value);
      break;
    case 6:
      var value = new pbtypes_gen_planner_movement_waypoint_pb.MovementWaypoint;
      reader.readMessage(value,pbtypes_gen_planner_movement_waypoint_pb.MovementWaypoint.deserializeBinaryFromReader);
      msg.addSpatialWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.planner.SpatialWaypointsCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.planner.SpatialWaypointsCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.planner.SpatialWaypointsCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.SpatialWaypointsCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreationUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getSampleUtime();
  if (f !== 0) {
    writer.writeSint64(
      2,
      f
    );
  }
  f = message.getPositionAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getVelocityAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getMaxAcceleration();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getSpatialWaypointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      pbtypes_gen_planner_movement_waypoint_pb.MovementWaypoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint64 creation_utime = 1;
 * @return {number}
 */
proto.planner.SpatialWaypointsCommand.prototype.getCreationUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
 */
proto.planner.SpatialWaypointsCommand.prototype.setCreationUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint64 sample_utime = 2;
 * @return {number}
 */
proto.planner.SpatialWaypointsCommand.prototype.getSampleUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
 */
proto.planner.SpatialWaypointsCommand.prototype.setSampleUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional float position_aggressiveness = 3;
 * @return {number}
 */
proto.planner.SpatialWaypointsCommand.prototype.getPositionAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
 */
proto.planner.SpatialWaypointsCommand.prototype.setPositionAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float velocity_aggressiveness = 4;
 * @return {number}
 */
proto.planner.SpatialWaypointsCommand.prototype.getVelocityAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
 */
proto.planner.SpatialWaypointsCommand.prototype.setVelocityAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float max_acceleration = 5;
 * @return {number}
 */
proto.planner.SpatialWaypointsCommand.prototype.getMaxAcceleration = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
 */
proto.planner.SpatialWaypointsCommand.prototype.setMaxAcceleration = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * repeated MovementWaypoint spatial_waypoints = 6;
 * @return {!Array<!proto.planner.MovementWaypoint>}
 */
proto.planner.SpatialWaypointsCommand.prototype.getSpatialWaypointsList = function() {
  return /** @type{!Array<!proto.planner.MovementWaypoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_planner_movement_waypoint_pb.MovementWaypoint, 6));
};


/**
 * @param {!Array<!proto.planner.MovementWaypoint>} value
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
*/
proto.planner.SpatialWaypointsCommand.prototype.setSpatialWaypointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.planner.MovementWaypoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.planner.MovementWaypoint}
 */
proto.planner.SpatialWaypointsCommand.prototype.addSpatialWaypoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.planner.MovementWaypoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.planner.SpatialWaypointsCommand} returns this
 */
proto.planner.SpatialWaypointsCommand.prototype.clearSpatialWaypointsList = function() {
  return this.setSpatialWaypointsList([]);
};


goog.object.extend(exports, proto.planner);
